import {
  ApplicationConfig,
  importProvidersFrom,
  inject,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideHttpClient, withFetch, withInterceptorsFromDi } from '@angular/common/http';
import { AppModule } from './app.module';
import { CartEntryService } from './shared/services/cart-entry.service';
import { LoginEntryService } from './shared/services/login-entry.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideHttpClient(withFetch(), withInterceptorsFromDi()),
    importProvidersFrom(AppModule),
    provideAppInitializer(() => inject(LoginEntryService).initBootstrapRedirects()),
    provideAppInitializer(() => inject(CartEntryService).initBootstrapCartRedirect()),
    provideAppInitializer(() => inject(CartEntryService).initBootstrapCheckoutRedirect()),
    //TODO enable hydration when it will be stable enught
    // provideClientHydration(withEventReplay(), withNoHttpTransferCache()),
  ],
};
